<template>
  <el-dialog
    :title="$t('text.record_pod_change')"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :show-close="false"
    @close="closeDialog()"
    width="500px"
    class="edit-group"
  >
    <div>
      <el-form
        label-width="120px"
        :model="form"
        ref="form"
        :rules="rules"
        label-position="top"
      >
        <el-form-item prop="AllocatedPod" :label="$t('text.pod_serial_number')">
          <el-input v-model="form.AllocatedPod" :disabled="true"> </el-input>
        </el-form-item>
        <el-form-item prop="ChangeDate" :label="$t('text.change_date')">
          <el-date-picker
            v-model="form.ChangedDate"
            type="datetime"
            class="wp-100"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item :label="$t('text.reason')" prop="Reason">
          <el-select
            v-model="form.Reason"
            filterable
            :placeholder="$t('text.reason')"
            class="wp-100"
          >
            <el-option
              v-for="item in reasonTypeOptions"
              :key="item"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button
        class="save-btn min-w-80"
        @click="submit()"
        :loading="loading"
        >{{ $t('text.save').toUpperCase() }}</el-button
      >
      <el-button class="cancel-btn min-w-80" @click="closeDialog()">{{
        $t('text.cancel').toUpperCase()
      }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import ApiService from '@/services/ApiService.js'
import swal from 'sweetalert'
import moment from 'moment'
export default {
  data() {
    return {
      dialogVisible: false,
      loading: false,
      form: {
        PodId: '',
        AllocatedPod: '',
        Reason: '',
        ChangedDate: new Date()
      },
      reasonTypeOptions: ['Physical Damage', 'Operational Malfunction', 'Lost'],
      rules: {
        Reason: [
          {
            required: true,
            message: 'Reason is required',
            trigger: 'blur'
          }
        ],
        ChangedDate: [
          {
            required: true,
            message: 'Change date is required',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  methods: {
    openDialog(item) {
      this.dialogVisible = true
      this.form.PodId = item.Id
      this.form.AllocatedPod = item.AllocatedPod
    },
    closeDialog() {
      this.form = {
        PodId: '',
        AllocatedPod: '',
        Reason: '',
        ChangedDate: new Date()
      }
      this.$refs.form.resetFields()
      this.dialogVisible = false
    },
    submit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.save()
        }
      })
    },
    save() {
      if (!this.$store.getters[`user/selecteOrganisationId`]) return false
      this.loading = true
      ApiService.SavePodChangeHistory({
        PodId: this.form.PodId,
        Reason: this.form.Reason,
        ChangedDate: moment(this.form.ChangedDate).format(
          'YYYY-MM-DD HH:mm:ss'
        ),
        OrganisationId: this.$store.getters[`user/selecteOrganisationId`]
      })
        .then(response => {
          this.loading = false
          if (response.data.success) {
            swal({
              icon: 'success',
              timer: 2000,
              title: this.$t('text.saved_successfully')
            })
            this.closeDialog()
            this.$parent.getData()
          } else {
            swal({
              icon: 'error',
              timer: 2000,
              title: this.$t('text.failed'),
              text: response.data.msg
            })
          }
        })
        .catch(() => {
          this.loading = false
          swal({
            icon: 'error',
            timer: 2000,
            title: this.$t('text.failed')
          })
        })
    }
  }
}
</script>
